module.exports = __webpack_public_path__ + "static/media/tada.4c863b6e.mp3";